import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon31: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        d="M10 0c5.52 0 10 4.373 10 9.773 0 .516-.078 1.246-.185 1.863l-.005.022a.263.263 0 0 1-.005.023c-.337 1.58-1.511 2.633-2.987 2.633a2.728 2.728 0 0 1-2.538-1.728 5 5 0 1 1-.189-5.461v-1.2a.455.455 0 0 1 .909 0v5.661c0 1.004.814 1.818 1.818 1.818 1.027 0 1.847-.735 2.098-1.913l.003-.011c.1-.57.172-1.251.172-1.707C19.09 4.88 15.023.91 10 .91S.91 4.88.91 9.773c0 4.893 4.067 8.864 9.09 8.864a9.212 9.212 0 0 0 5.004-1.462L13.351 17a.455.455 0 0 1 .095-.905l2.713.286c.25.026.43.25.404.499l-.285 2.713a.454.454 0 1 1-.904-.096l.167-1.59-.148.098A10.126 10.126 0 0 1 10 19.547c-5.52 0-10-4.373-10-9.774C0 4.373 4.48 0 10 0Zm0 5.91a4.091 4.091 0 1 0 0 8.182 4.091 4.091 0 0 0 0-8.183Z"
      />
    </Svg>
  )
}
